<template>
	<div id="app"></div>
</template>

<script>
	export default {
		name: 'app',
		components: {},
		created() {
			if (window.location.hash.length > window.location.pathname.length) {
				window.location.href =
					process.env.VUE_APP_REDIRECT + window.location.hash;
			} else {
				window.location.href =
					process.env.VUE_APP_REDIRECT +
					'#' +
					window.location.pathname +
					window.location.search;
			}
		}
	};
</script>

<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		height: 100%;
	}
	body {
		margin: 0;
		height: 100%;
	}
	html {
		height: 100%;
	}
</style>
